import './index.scss';
import React, {useEffect, useState} from 'react';
import {
    IconPlusSmallWhite, IconPencilNoted, IconTrashOutline,
    TemplateIconDocument, TemplateIconImage, TemplateIconMultipleChoice, TemplateIconText, TemplateIconVideo, TemplateIconAudio,
    IconRearrange, IconThreeDotsVertical
} from '../../icons/svgs';


function Tray({slides,deleteSlide,selectedSlide,setSelectedSlide,selectedSlideIndex,setSelectedSlideIndex,setActionUpdateTemplate,lessonTitle,setSlides,setOpenModalSaveTitleLesson, reRender}) {
    const [activeIndex, setActiveIndex] = useState(selectedSlideIndex || 0);
    const [saveDisabled, setSaveDisabled] = useState('');
    // const [currentSlides, setCurrentSlides] = useState(slides);

    const showModalNewSlide = () => {
        setActionUpdateTemplate(false)
        window.jQuery('#tbcourse-modal-new-slide').modal('show');
    }

    const showModalChangeTemplate = () => {
        setActionUpdateTemplate(true)
        window.jQuery('#tbcourse-modal-new-slide').modal('show');
    }

    const showModalEditSlideContent = () => {
        window.jQuery('#tbcourse-modal-edit-slide-content').modal('show');
    }
    const handleClick = (index) => {
        const slide = slides[index];
        setSelectedSlide(slide);
        setSelectedSlideIndex(index);
        setActiveIndex(index);
    }

    const getSlidesToDisplay = () => {
        // let nextIndex = (activeIndex + 1) % slides.length;
        // return [slides[activeIndex], slides[nextIndex]]; // show active and the next one
        if(slides.length === 0) {
            return [];
        }

        if (slides.length === 1) {
            return [slides[0]];
        }

        if (slides.length > 2) {
            let nextIndex = (activeIndex + 1) % slides.length;
            return [slides[activeIndex], slides[nextIndex]]; // show active and the next one
        }

        // If the active slide is the last one, do not change order, just show the last two slides
        if (activeIndex === slides.length - 1) {
            let prevIndex = activeIndex - 1;
            return [slides[prevIndex], slides[activeIndex]];
        } else {
            // Otherwise show the active and next slide
            let nextIndex = (activeIndex + 1) % slides.length;
            return [slides[activeIndex], slides[nextIndex]];
        }
    };

    const handleOpenModalReorderSlide = () => {
        window.jQuery('#tbcourse-modal-reorder-slides').modal('show');
    }
    const handleOpenModalEditSlideName = () => {
        window.jQuery('#tbcourse-modal-edit-slide-name').modal('show');
    };

    const handleDeleteSlide = () => {
        window.jQuery('#tbcourse-modal-confirm-delete-slide').modal('show');
    }

    useEffect(() => {
        if (selectedSlide) {
            setSaveDisabled(selectedSlide.saveDisabled)
        }
    }, [selectedSlide]);

    useEffect(() => {
        setActiveIndex(selectedSlideIndex);
    }, [selectedSlideIndex]);

    const displayedSlides = getSlidesToDisplay();

    const templateIcons = {
        document: <TemplateIconDocument />,
        image: <TemplateIconImage />,
        multiplechoice: <TemplateIconMultipleChoice />,
        text: <TemplateIconText />,
        video: <TemplateIconVideo />,
        audio: <TemplateIconAudio />
    };

    return (
        <div className='tbcourse-tray'>
            <div className="row g-0 mb-2">
                <div className="col slides-navigation-view">
                {displayedSlides.length > 0 && displayedSlides.map((item, index) => (
                    item && (
                        <button
                            type="button"
                            className={`btn slides-navigation-view-item ${selectedSlideIndex===slides.indexOf(item) ? ' active ':''}`}
                            onClick={() => handleClick(slides.indexOf(item))}
                            key={index}
                            >
                            {item.name}
                        </button>
                    )
                ))}
                </div>
                <div className="col-auto">
                    <button type='button' className='btn btn-see-more ms-1' onClick={handleOpenModalReorderSlide}>See More</button>
                </div>
            </div>
            <ul className='d-none'>
                {slides.length > 0 && slides.map((item, index) => (
                    <li className={`${selectedSlideIndex === index ? 'font-weight-700': ''}`} key={index}>{item.name}</li>
                ))}
            </ul>

            <div className="row g-3 mb-3">
                <div className="col d-grid">
                    <button type="button" className='btn btn-add-slide font-weight-500' onClick={showModalNewSlide} disabled={saveDisabled}>
                        {/* New Slide <ReactSVG src={IconPlusSmallWhite} wrapper='span'/> */}
                        New Slide <IconPlusSmallWhite />
                    </button>
                </div>
                {(selectedSlide &&
                <div className="col-auto d-flex align-items-center">
                    <button type='button' className='btn btn-circle btn-primary' onClick={handleOpenModalEditSlideName}>
                        <div className="center-vertical">
                            <span><IconPencilNoted /></span>
                        </div>
                    </button>
                    {(selectedSlide?.canDelete() &&
                        <button type='button' className='btn btn-circle btn-danger ms-2' onClick={handleDeleteSlide} disabled={saveDisabled}>
                            <div className="center-vertical">
                                <span><IconTrashOutline /></span>
                            </div>
                        </button>
                    )}
                </div>
                )}
            </div>
            <div className="row">
                <div className="col">
                    {selectedSlide && (
                        <div className='current-preview-slide-item'>
                            <div className='info'>
                                {/* <div className='reorder'>
                                    <IconRearrange />
                                </div> */}
                                <div className='icon'>
                                    {templateIcons[selectedSlide.template.iconType()]}
                                </div>
                                <div className='name'>{selectedSlide.name}</div>
                            </div>
                            <div className='actions'>
                                <div className='dropdown dropstart'>
                                    <button type='button' className='btn dropdown-toggle' data-bs-toggle="dropdown" aria-expanded="false">
                                        <IconThreeDotsVertical/>
                                    </button>
                                    <ul className='dropdown-menu'>
                                        <li><a role='button' className='btn dropdown-menu-item' onClick={showModalChangeTemplate}>Change Template</a></li>
                                        <li><a role='button' className='btn dropdown-menu-item' onClick={showModalEditSlideContent}>Edit Content</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Tray;